import { SubmitData } from '@shared/utils';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { useSignsBollardsStore } from './useSignsBollardsStore';

export interface UseHandleSubmitOptions {
  confirmationRoute: string;
  endpoint: string;
}

export const useHandleSubmit = ({
  confirmationRoute,
  endpoint,
}: UseHandleSubmitOptions) => {
  const navigate = useNavigate();
  const { update } = useSignsBollardsStore();

  return useMutation({
    mutationFn: (variables: { payload: any; isLoggedInUser: any }) =>
      SubmitData({ ...variables, endpoint }),
    onSuccess: (data) => {
      update('confirmation', data);
      navigate(confirmationRoute);
    },
    onError: (error) => {
      Sentry.captureException(error);
      navigate(confirmationRoute);
    },
  });
};
